// use-create-session.ts — Sessions-list suite, action.

'use client';

import { useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import type { CreateSessionRequest, CreateSessionResponse } from '@cabal/shared/domain/session/types.js';
import { useApi } from '@/contexts/api';
import { useActionHook } from '@/lib/query/use-action-hook';
import type { ActionResult } from '@/types/async-protocol';
import { sessionsListKeys } from './keys';

export type CreateSessionVars = CreateSessionRequest;

export function useCreateSession(): ActionResult<CreateSessionVars, CreateSessionResponse> {
  const api = useApi();
  const apiSessions = api.sessions;
  const queryClient = useQueryClient();

  return useActionHook<CreateSessionVars, CreateSessionResponse>(
    useMemo(
      () => ({
        mutationFn: (body) => apiSessions.create({ body }),
        onInvalidate: () => {
          queryClient.invalidateQueries({ queryKey: sessionsListKeys.all });
        },
      }),
      [apiSessions, queryClient],
    ),
  );
}
